import { Button, Dropdown, Tooltip } from 'antd'
import { ArrowDownAZ, ImagePlus, MoreVertical, Option, Trash2 } from 'lucide-react'
import { useFFEStore } from '../../store/ffeStore'
import { Group } from '../../types/ffe'
import { useShallow } from 'zustand/react/shallow'
import { ItemType } from 'antd/es/menu/interface'

export const MoreGroupControls = ({ group }: { group: Group }) => {
  const updateGroup = useFFEStore((state) => state.updateGroup)
  const itemsInGroup = useFFEStore(
    useShallow((state) =>
      state.document.lineItems.filter((item) => item.groupId === group.id)
    )
  )
  const sortLineItemsInGroupBy = useFFEStore(
    (state) => state.sortLineItemsInGroupBy
  )

  const dropdownItems: Array<ItemType> = [
    {
      key: 'bulk-upload',
      icon: <ImagePlus className="h-4 w-4" />,
      label: 'Bulk Image Upload Into Group',
      onClick: () => {
        useFFEStore.getState().setBulkImageUploadDrawerId(group.id)
        useFFEStore.getState().setIsBulkImageDrawerOpen(true)
      }
    },
    {
      key: 'order-by',
      icon: <ArrowDownAZ className="h-4 w-4" />,
      label: `Reorder Items By`,
      children: [
        {
          key: '1-1',
          label: 'Code',
          onClick: () => {
            sortLineItemsInGroupBy(group.id, 'code')
          }
        },
        {
          key: '1-2',
          label: 'Title',
          onClick: () => {
            sortLineItemsInGroupBy(group.id, 'name')
          }
        }
      ]
    },
    {
      key: 'alternatives',
      icon: <Option className="h-4 w-4" />,
      label: `${!group.isAlternatives ? 'Enable' : 'Disable'} Alternatives`,
      onClick: () => {
        updateGroup(group.id, {
          ...group,
          isAlternatives: !group.isAlternatives,
          selectedItemId: itemsInGroup[0]?.id
        })
      }
    },
    {
      key: 'delete-group',
      danger: true,
      icon: <Trash2 className="h-4 w-4" />,
      label: 'Delete Group',
      onClick: () => {
        useFFEStore.getState().removeGroup(group.id)
      }
    }
  ]

  return (
    <Dropdown
      menu={{
        items: dropdownItems
      }}
      trigger={['click']}
    >
      <Tooltip title="More group options">
        <Button type="text" icon={<MoreVertical className="h-4 w-4" />} />
      </Tooltip>
    </Dropdown>
  )
}
